var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgThorn(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.30957 7.19988C8.42957 6.68988 15.5796 6.68988 22.6996 7.19988C15.5796 7.70988 8.42957 7.70988 1.30957 7.19988Z",
    fill: "#FF5E00"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1.30957 12.0002C8.42957 11.4902 15.5796 11.4902 22.6996 12.0002C15.5796 12.5102 8.42957 12.5102 1.30957 12.0002Z",
    fill: "#FF5E00"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M1.30957 16.8C8.42957 16.29 15.5796 16.29 22.6996 16.8C15.5796 17.31 8.42957 17.31 1.30957 16.8Z",
    fill: "#FF5E00"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgThorn);
export default __webpack_public_path__ + "static/media/thorn.ca7a2898678dbd4cfac4e12ca72ca969.svg";
export { ForwardRef as ReactComponent };